// @flow

import * as React from "react";
import { Form } from "semantic-ui-react";

import { call } from "../../../Utilities/index";

type Props = {
  error: boolean,
  fluid?: boolean,
  name: string,
  onBlur?: Function,
  onChange: Function,
  onFocus?: Function,
  value: boolean,
};

export function Checkbox({ onBlur, onChange, onFocus, value, ...props }: Props) {
  return (
    <Form.Checkbox
      {...props}
      checked={!!value}
      onBlur={(...args) => call(onBlur)({ ...props, value }, ...args)}
      onClick={(...args) => call(onChange)({ ...props, value: !value }, ...args)}
      onFocus={(...args) => call(onFocus)({ ...props, value }, ...args)}
    />
  );
}

export default Checkbox;
